import { render } from "./ModulesAndLessons.vue?vue&type=template&id=d7e82b40"
import script from "./ModulesAndLessons.vue?vue&type=script&lang=js"
export * from "./ModulesAndLessons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__